import { basicListAddEditDltInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { patInqActionTypes } from '../actions/patInqActionTypes';

const resetServerValue = (state, action) => ({
  ...state,
  serverRequestError: action.data && action.data.serverRequestError,
});

const ProducerAuditTrail = (state = { ...basicListAddEditDltInitialState }, action = null) => {
  switch (action.type) {
    // Configure Page Details
    case patInqActionTypes.SET_PATINQ_DETAILS_RESPONSE:
      return {
        ...state,
        subModuledetails: action.data,
      };
    case patInqActionTypes.RESET_SERVER_VALUE_PATINQ:
      return resetServerValue(state, action);
    case commonTypes.RESETSTORE:
      return basicListAddEditDltInitialState;
    default:
      return state;
  }
};

export default ProducerAuditTrail;
